<template>
  <div>
<!--    <div class="datepicker-trigger" v-if="isMobileDevice()">-->
<!--      <el-date-picker-->
<!--          size="medium"-->
<!--          v-if="range"-->
<!--          ref="dater"-->
<!--          style="width:100%"-->
<!--          :start-placeholder="startPlaceholder"-->
<!--          :end-placeholder="toPlaceholder"-->
<!--          v-model="content"-->
<!--          :value-format="elValueFormat"-->
<!--          :format="displayFormat"-->
<!--          type="daterange"-->
<!--          :placeholder="placeholder"-->
<!--          :picker-options="pickerOptions"-->
<!--          @change="e=>$emit('change', e)"-->
<!--      ></el-date-picker>-->
<!--      <AirbnbStyleDatepicker-->
<!--        :trigger-element-id="'datepicker-trigger'"-->
<!--        :mode="'range'"-->
<!--        :fullscreen-mobile="true"-->
<!--        @date-one-selected="val => {setRange(val,bookingRange[1])}"-->
<!--        @date-two-selected="val =>{setRange(bookingRange[0],val)}"-->
<!--      />-->
<!--    </div>-->
<!--    <template v-else>-->
      <el-date-picker
        size="medium"
        v-if="range"
        ref="dater"
        style="width:100%"
        :start-placeholder="startPlaceholder"
        :end-placeholder="toPlaceholder"
        v-model="content"
        :value-format="elValueFormat"
        :format="displayFormat"
        type="daterange"
        :placeholder="placeholder"
        :picker-options="pickerOptions"
        @change="e=>$emit('change', e)"
      ></el-date-picker>
      <el-date-picker
        v-else
        ref="dater"
        :type="type"
        :placeholder="placeholder"
        style="width:100%"
        start-placeholder="απο"
        end-placeholder="εως"
        v-model="content"
        :value-format="elValueFormat"
        :format="displayFormat"
        @change="e=>$emit('change', e)"
        xchange="updateModel"
      ></el-date-picker>
<!--    </template>-->
  </div>
</template>

<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import * as dateHelper from "date-fns";
// import { formatISO } from "date-fns";
export default {
  name: "s-dater",
  data() {
    return {
      content: this.range ? [] : null,
    };
  },
  props: {
    startPlaceholder: { type: String, default: "from" },
    toPlaceholder: { type: String, default: "to" },
    value: { default: null },
    displayFormat: {
      default: "dd/MM/yyyy HH:mm", //
    },
    placeholder: { type: String, default: "dd/mm/yyyy" },
    type: { type: String, default: "date" },
    range: { type: Boolean, default: false },
    exportFormat: {
      default: "unxtimestamp",
    },
    valueFormat: {
      default: "unxtimestamp",
    },
  },
  computed: {
    elValueFormat() {
      _log_("hel.ww..form..", this.valueFormat);
      // if (this.valueFormat == "auto")
      //   return (this.value + "").indexOf("/") > 0
      //     ? "dd/MM/yyyy"
      //     : "unxtimestamp";
      return this.valueFormat == "unxtimestamp"
        ? "timestamp"
        : this.valueFormat;
    },
    pickerOptions() {
      var vm = this;
      return {
        shortcuts: [
          {
            text: "Σήμερα",
            onClick(picker) {
              const date = new Date();
              vm.content = [date.getTime(), date.getTime()];
            },
          },
          {
            text: "Αύριο",
            onClick(picker) {
              const date = new Date();
              vm.content = [
                date.getTime() + 3600 * 1000 * 24,
                date.getTime() + 3600 * 1000 * 24,
              ];
              // date.setTime();
              picker.$emit("pick", vm.content);
            },
          },
          {
            text: "7 μέρες",
            onClick(picker) {
              const date = new Date();
              vm.content = [
                date.getTime(),
                date.getTime() + 3600 * 1000 * 24 * 7,
              ];
              // date.setTime();
              picker.$emit("pick", vm.content);
            },
          },
          {
            text: "1 μήνα",
            onClick(picker) {
              const date = new Date();
              vm.content = [
                date.getTime(),
                date.getTime() + 3600 * 1000 * 24 * 31,
              ];

              // date.setTime();
              picker.$emit("pick", vm.content); //[new Date(),(date.getTime() - 3600 * 1000 * 24 * 7)]);
            },
          },
        ],
      };
    },
  },
  watch: {
    // value(value, ov) {
    //   if (value && value != ov) _log_("hel.ww.PVV.", value, ov);
    // },
    value: {
      handler(val, oldval) {
        let valTrans = null,
          contentTrans = null;
        if (!val) return;
        if (this.range) {
          this.content = this.content ? this.content : [];
          valTrans = [];
          if (val[0])
            valTrans[0] = new Date(
              this.valueFormat == "unxtimestamp" && !isNaN(val[0])
                ? val[0] * 1000
                : val[0]
            );
          if (val[1])
            valTrans[1] = new Date(
              this.valueFormat == "unxtimestamp" && !isNaN(val[1])
                ? val[1] * 1000
                : val[1]
            );
          _log_(
            "hel.ww.P.",
            JSON.stringify(this.content[0]),
            JSON.stringify(valTrans[0])
          );
          return;
          // if (this.content[0]) valTrans[0] = new Date(this.content[0]);
          // if (this.content[1]) valTrans[1] = new Date(this.content[1]);
          if (
            JSON.stringify(this.content[0]) == valTrans[0] &&
            this.content[1] == valTrans[1]
          )
            return;
        } else {
          if (val)
            valTrans = new Date(
              this.valueFormat == "unxtimestamp" && !isNaN(val)
                ? val * 1000
                : val
            );

          if (this.content) contentTrans = new Date(this.content);

          if (contentTrans == valTrans) return;
        }
        this.content = valTrans;
      },
      immediate: true,
    },
    content(value, oldVal) {
      if (JSON.stringify(value) == JSON.stringify(this.value)) return;
      // if (!value) return;
      _log_("hel.ww.P.", this.value, value, oldVal);
      if (value != oldVal)
        if (!this.range) {
          if (this.exportFormat == "unxtimestamp") value = value / 1000;
          else if (this.exportFormat == "ISO")
            value = dateHelper.format(
              new Date(value),
              "YYYY-MM-DD[T]HH:mm:ssZZ"
            );
          else {
            const d = new Date(value);
            value = dateHelper.format(new Date(value), this.exportFormat);
          }
          this.$emit("input", value);
          // this.$emit("change", value);
        } else {
          if (!value) {
            if (oldVal) this.$emit("input", []);
            return;
          }
          if (!value.length) {
            if (oldVal) this.$emit("input", []);
            return;
          }
          //      _log_("hel.ww..", value[0],dateHelper.format((new Date(value[0])),this.exportFormat));
          // //   _log_("hel.ww..", value);
          var e = value;
          if (this.exportFormat == "unxtimestamp") {
            e =
              this.valueFormat == "unxtimestamp"
                ? [Math.floor(value[0] / 1000), Math.floor(value[1] / 1000)]
                : e;
            this.$emit("input", e);
          } else if (this.exportFormat == "ISO")
            e = [
              dateHelper.format(new Date(value[0]), "YYYY-MM-DD[T]HH:mm:ssZZ"),
              dateHelper.format(new Date(value[1]), "YYYY-MM-DD[T]HH:mm:ssZZ"),
            ];
          else
            e = [
              dateHelper.format(new Date(value[0]), this.exportFormat),
              dateHelper.format(new Date(value[1]), this.exportFormat),
            ];
          if (e) this.$emit("input", e);
          // this.$emit("change", e);
        }
    },
  },
  created() {
    // this.content = [date.getTime(), date.getTime()];
  },
  methods: {
    updateModel(val) {
      this.$emit("change", val);
      this.$emit("input", val);
    },
    init() {},
  },
};
</script>
<style>
.el-range-editor--medium.el-input__inner {
  height: 42px;
}
</style>
